require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-regular-expressions-reuse-patterns-using-capture-groups.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-regular-expressions-reuse-patterns-using-capture-groups");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-regular-expressions-reuse-patterns-using-capture-groups!./.cache/json/javascript-algorithms-and-data-structures-regular-expressions-reuse-patterns-using-capture-groups.json
// module id = 2503
// module chunks = 231608221292675